const DEVICE_ID_KEY = "device_id";

function generateUuid() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  // Fallback для старых браузеров
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  let id = null;
  try {
    id = localStorage.getItem(DEVICE_ID_KEY);
  } catch {
    // localStorage недоступен (приватный режим, отключён) — без device_id
    return null;
  }
  if (!id) {
    id = generateUuid();
    try {
      localStorage.setItem(DEVICE_ID_KEY, id);
    } catch {
      // ignore
    }
  }
  return id;
}

export function getDeviceInfo() {
  try {
    const screen = window.screen
      ? `${window.screen.width}x${window.screen.height}`
      : null;
    const info = {
      userAgent: navigator?.userAgent || null,
      platform: navigator?.platform || null,
      language: navigator?.language || null,
      screen,
      timezone: Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone || null,
    };
    const utf8 = new TextEncoder().encode(JSON.stringify(info));
    let binary = "";
    for (let i = 0; i < utf8.length; i++) {
      binary += String.fromCharCode(utf8[i]);
    }
    return btoa(binary);
  } catch {
    return "";
  }
}
